import { render, staticRenderFns } from "./ConsultList.vue?vue&type=template&id=12aa2c4c&scoped=true"
import script from "./ConsultList.vue?vue&type=script&lang=js"
export * from "./ConsultList.vue?vue&type=script&lang=js"
import style0 from "./ConsultList.vue?vue&type=style&index=0&id=12aa2c4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aa2c4c",
  null
  
)

export default component.exports